import { useEffect, useState } from "react";
import { school_api } from "../../atoms/api";
const useFetchSchool = (url, depens = []) => {
  const [apiData, setApiData] = useState({
    data: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    school_api
      .get(url)
      .then((res) => {
        setApiData({ ...apiData, data: res.data, loading: false });
      })
      .catch((err) => {
        setApiData({ ...apiData, error: err, loading: false });
      });
  }, [...depens]);

  return apiData;
};

export default useFetchSchool;
